export const baseClass = 'orbit-slider';

export enum Colors {
  BLUE = '#0550E2',
  LIGHT_BLUE = '#E9F1FD',
}

export enum DotSizes {
  INNER_SMALL = 5.5,
  INNER_MEDIUM = 6,
  INNER_LARGE_GLOW = 9,

  OUTER_SMALL = 4.5,
  OUTER_MEDIUM = 5,
  OUTER_LARGE_GLOW = 6,
}

export enum OrbitDefaults {
  DEFAULT_DURATION = 60,
}

export const ViewBoxDimensions = {
  MIN_X: -500,
  MIN_Y: -500,
  WIDTH: 1000,
  HEIGHT: 1000,
} as const;

export enum OrbitConfig {
  INNER_RADIUS = 400,
  INNER_COUNT = 40,
  INNER_DURATION = 220,
  OUTER_RADIUS = 490,
  OUTER_COUNT = 50,
  OUTER_DURATION = 260,
}

export const INNER_ORBIT_BIG_INDEXES = [3, 9, 15, 21, 27, 33, 39];
export const OUTER_ORBIT_BIG_INDEXES = [7, 17, 25, 35, 45];

export const OrbitSliderDimensions = {
  VISIBLE_HEIGHT_RATIO: 0.6,
  get VISIBLE_HEIGHT() {
    return ViewBoxDimensions.HEIGHT * this.VISIBLE_HEIGHT_RATIO;
  },
} as const;
